import { type FC, useMemo } from "react";

import { useModal } from "../../camkit/core/hooks";
import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { CofConfigId, ResourceKind } from "../../gql-generated/types";
import { PageHeader } from "../../layout/components";
import { Flexbox } from "../../shared/components";
import { useOrgChildResources, useSelectedLensCentralOrganizationNotIncludesCamkitOrgs } from "../../shared/hooks";

import { AddHostedLensModal } from "./AddHostedLensModal";
import { GenerateHostedLensButton } from "./GenerateHostedLensButton";
import { HostedLensesList } from "./HostedLensesList";
import { HostedLensTitle } from "./messages.generated";

export const HostedLensesPage: FC = () => {
    const [modalProps, showModal] = useModal();
    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;

    const { resourceContainers, loading } = useOrgChildResources({
        kind: ResourceKind.LensSpaces,
    });

    const selectedOrganizationV3 = useSelectedLensCentralOrganizationNotIncludesCamkitOrgs();
    const isDisabled = useMemo(() => {
        if (isMyLensesOrgsV2Enabled && loading) {
            return true;
        }
        if (isMyLensesOrgsV2Enabled) {
            return resourceContainers.length === 0;
        }
        return selectedOrganizationV3 === null || selectedOrganizationV3.lensSpacesList.length === 0;
    }, [isMyLensesOrgsV2Enabled, loading, resourceContainers.length, selectedOrganizationV3]);

    return (
        <>
            <Flexbox>
                <PageHeader>
                    <HostedLensTitle />
                </PageHeader>
                <GenerateHostedLensButton onClick={showModal} isDisabled={isDisabled} />
            </Flexbox>
            <HostedLensesList generateCTA={<GenerateHostedLensButton onClick={showModal} isDisabled={isDisabled} />} />
            <AddHostedLensModal {...modalProps} />
        </>
    );
};
